define("tmds/geometry/Polyline", [
	"jquery",
	"./Extent",
	"./Geometry",
	"../validator"
], function($, Extent, Geometry, validator) {
	"use strict";

	/**
	 * construct a new polyline
	 * @param options {Object} option object with below structure
	 * 		{ 
	 * 			paths: [[[200, 100],
	 * 				   [300, 400],
	 * 				   [200, 400],
	 * 				   ...
	 * 				 ]] 
	 * 		}
	 */
	var Polyline = function(options) {
		// default point settings
		this.paths = [];
		
		if (options != undefined) {
			if (validator.isDataObject(options)) {
				if (options.paths != undefined) {
					if (validator.isSvgPathArray(options.paths)) {						
						this.paths = options.paths;
					}
					else {
						throw new Error('Invalid Polyline paths value - ' + options.paths + ' passed');
					}
				}
			}
			else {
			 	throw new Error('Invalid options values - ' + options + ' passed');
			}
		}
	};
	
	/**
	 * get the extent that wraps the polyline geometry
	 * @return {Object} in JSON format of tmds.geometry.Extent
	 */
	function toExtent() {
		var xmin = 1000000, ymin = 1000000,
			xmax = 0, ymax = 0 ;
		
		this.paths.forEach(function(aPath) {
			aPath.forEach(function(pnt) {
				xmin = Math.min(xmin, pnt[0]);
				xmax = Math.max(xmax, pnt[0]);
				ymin = Math.min(ymin, pnt[1]);
				ymax = Math.max(ymax, pnt[1]);
			});
		});
		
		return new Extent({
			xmin: xmin,
			ymin: ymin,
			xmax: xmax,
			ymax: ymax
		});
	}
	
	function toJson() {
		return {
			paths: this.paths,
			type: this.type
		};
	}
	
	Polyline.prototype = $.extend(Object.create(Geometry.prototype), {		
		declaredClass: "tmds.geometry.Polyline",
		type: "Polyline",
		'toExtent' : toExtent,
		'toJson' : toJson
	});
	
	return Polyline;
});